import { Routes, Route, Navigate } from 'react-router-dom';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { VerifyEmail } from './pages/VerifyEmail';
import { ForgotPassword } from './pages/ForgotPassword';
import { ResetPassword } from './pages/ResetPassword';
import { Home } from './pages/Home';
import { VideosPage } from './pages/Videos';
import { SalonPage } from './pages/Salon';
import { AdminDashboard } from './pages/AdminDashboard';
import { AIAdmin } from './pages/AIAdmin';
import { Layout } from './components/Layout';
import { DMPage } from './pages/DM';
import { Settings } from './pages/Settings';
import { Mailbox } from './pages/Mailbox';
import { ContactPage } from './pages/Contact';
import { UserProfile } from './pages/UserProfile';
import { TokuRanking } from './pages/Toku';
import { AuditLogs } from './pages/AuditLogs';
import { UStore } from './pages/UStore';

import Neighbors from './pages/Neighbors';


function LlpContactFloatingLink() {
    return (
        <a
            id="llp-contact-floating-link"
            href="/contact"
            aria-label="LifeLabo Portal 問い合わせ"
            style={{
                position: 'fixed',
                right: '18px',
                bottom: '18px',
                zIndex: 2147483647,
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                padding: '10px 14px',
                borderRadius: '999px',
                background: 'linear-gradient(135deg, #0f766e, #134e4a)',
                color: '#fff',
                fontWeight: 800,
                fontSize: '13px',
                lineHeight: 1,
                textDecoration: 'none',
                boxShadow: '0 14px 35px rgba(15, 23, 42, 0.28)',
                border: '1px solid rgba(255, 255, 255, 0.35)',
            }}
        >
            問い合わせ
        </a>
    );
}

function App() {
    return (
        <>
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="neighbors" element={<Neighbors />} />
                <Route path="videos" element={<VideosPage />} />
                <Route path="salon" element={<SalonPage />} />
                <Route path="admin" element={<AdminDashboard />} />
                <Route path="admin/logs" element={<AuditLogs />} />
                <Route path="ai-admin" element={<AIAdmin />} />
                <Route path="mailbox" element={<Mailbox />} />
                <Route path="audience" element={<DMPage />} />
                <Route path="contact" element={<ContactPage />} />
                <Route path="toku" element={<TokuRanking />} />
                <Route path="u-store" element={<UStore />} />
                <Route path="settings" element={<Settings />} />
                <Route path="users/:userId" element={<UserProfile />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <LlpContactFloatingLink />
        </>
    );
}

export default App;
